export default {
    mainProjects: [
        {
            title: 'Movie Streaming Service API',
            subtitle: 'AWS REST App & NoSQL DB',
            photo: require('@/assets/movie-azure.jpg'),
            alt: 'A bowl of popcorn',
            summary: 'Users search by title to determine which streaming services host said movie. A Puppeteer JS web scrapper crawls Google and Rotten Tomatoes for relevant information; that information is then used to maintain the AWS DynamoDB.',
            tags: ['AWS', 'REST API', 'DynamoDB', 'NodeJS'],
            source: "https://github.com/oriordac/summer_stream",
            video: 'https://www.youtube.com/embed/HyQhDLptMdY',
            site: 'https://oriordac.github.io/AWS-Movie-Vue-App/',
            id: 'awsMovie',
            demo: 'awsDemo',
            get ariaDemo() { return `${this.id} ${this.demo}`},
            get ariaSource() {return `View the source code of the ${this.title}`},
            get ariaSite() {return `View the live site for the ${this.title}`}
        },
        {
            title: 'Fitness Vue App',
            subtitle: 'Vue & Express',
            photo: require('../assets/fitness-app.jpg'),
            alt: 'A jogger climbing stairs',
            summary: 'Users can track daily exercises/diet, customize profile and goals, and share and comment on social posts. NodeJS and Express for back-end server to serve up dynamic front-end pages. Still in development; future plans include MongoDB and a follow/follower feature.',
            tags: ['VueJS', 'NodeJS', 'Express', 'Bulma'],
            source: "https://github.com/oriordac/web-dev-app-project",
            video: 'https://www.youtube.com/embed/H6wcMcME3hY',
            site: 'https://sleepy-reef-66034.herokuapp.com/about',
            id: 'fitnessApp',
            demo: 'fitnessDemo',
            get ariaDemo() { return `${this.id} ${this.demo}`},
            get ariaSource() {return `View the source code of the ${this.title}`},
            get ariaSite() {return `View the live site for the ${this.title}`}
        },
        {
            title: 'Julio-Claudian Family Tree',
            subtitle: 'Extensive MySQL DB',
            photo: require('../assets/julio-arch.jpg'),
            alt: 'Triumphal Arch of Constantine',
            summary: 'Designed a database showcasing the Julio-Claudians from Roman Antiquity. Focus on familial relations, time in public office, public imagery depicting family members, and famous events. OBDC with Microsoft Access to colaborate with former history professor.',
            tags: ['MySQL Workbench', 'MS Access', 'ODBC'],
            source: 'https://github.com/oriordac/julio-claudian-family-tree-db',
            video: 'https://www.youtube.com/embed/dMMtOCCPqW0',
            site: 'NA',
            note: 'Since this is a database, there is no live site',
            id: 'romanDatabase',
            demo: 'romanDemo',
            get ariaDemo() { return `${this.id} ${this.demo}`},
            get ariaSource() {return `View the source code of the ${this.title}`},
            get ariaSite() {return `View the live site for the ${this.title}`}
        }
    ]
}